import React from "react";
import get from "lodash/get";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import BSInput from "../../../common/js/components/BSInput";

const InvoiceMonth = (props) => {
    const { disableInputs, errors, handlePeriodMonthChange, monthDetail, periodNumber } = props;

    const handleFreeRentCheckbox = (event, checked) => {
        handlePeriodMonthChange(periodNumber, monthDetail.monthInPeriod, event.target.value, checked);
    };

    const handleApplyMonthlyDiscountOrRate = (event) => {
        handlePeriodMonthChange(periodNumber, monthDetail.monthInPeriod, event.target.id, event.target.value);
    };

    const hasDiscount = () => {
        return monthDetail.discountPercent && monthDetail.discountPercent > 0;
    };

    const hasFreeRent = () => {
        return monthDetail.freeRent;
    };

    return (
        <TableRow>
            <TableCell align="center">
                <span className="monthCircle">{monthDetail.monthInPeriod + 1}</span>
            </TableCell>
            <TableCell align="center">
                {monthDetail.startDate}
                <ArrowForward style={{ height: "12px" }} />
                {monthDetail.endDate}
            </TableCell>
            <TableCell align="center">
                <Checkbox
                    checked={monthDetail.freeRent}
                    onChange={(e, c) => handleFreeRentCheckbox(e, c)}
                    value="freeRent"
                    disabled={disableInputs === true}
                    color="primary"
                    style={{ padding: "0 2vw" }}
                />
            </TableCell>
            <TableCell numeric align="center">
                <BSInput
                    id="discountPercent"
                    value={monthDetail.discountPercent}
                    error={get(errors, `${periodNumber}-${monthDetail.monthInPeriod}.discountPercent`, null)}
                    onChange={(e) => handleApplyMonthlyDiscountOrRate(e)}
                    disabled={disableInputs === true || hasFreeRent()}
                    endAdornment="%"
                    numeric
                    extraFormControlStyles={{ width: "70%" }}
                />
            </TableCell>
            <TableCell numeric align="center">
                <BSInput
                    id="rate"
                    value={monthDetail.rate}
                    error={get(errors, `${periodNumber}-${monthDetail.monthInPeriod}.rate`, null)}
                    onChange={(e) => handleApplyMonthlyDiscountOrRate(e)}
                    disabled={disableInputs === true || hasDiscount() || hasFreeRent()}
                    startAdornment="$"
                    numeric
                    extraFormControlStyles={{ width: "70%" }}
                />
            </TableCell>
        </TableRow>
    );
};

export default InvoiceMonth;
